import { Injectable } from '@angular/core';
import {
  AmdocsCookieService
} from 'amdocs-auth-package';

@Injectable({
  providedIn: 'root'
})
export class AuthServiceService {


  constructor(private cookieService: AmdocsCookieService) { }

  
  isAuthenticated() {
    let open_Id = this.cookieService.get('open_id_token');
    let open_Id_expiration = this.cookieService.get('open_id_token_expiration');
    return  ((open_Id   &&  open_Id_expiration )); // Example: check if token exists in local storage
  }
}
